import languageMeta, { defaultLanguage } from './languageMeta';
import { languageAssets, languageCodes } from './languages.generated';

const languageMap = languageCodes.reduce((acc, code) => {
  const meta = languageMeta[code] || {};
  acc[code] = {
    label: meta.label || code,
    dir: meta.dir || 'ltr',
  };
  return acc;
}, {});

export const supportedLanguages = languageCodes;
export const fallbackLanguage = defaultLanguage;

export const i18nResources = supportedLanguages.reduce((acc, code) => {
  acc[code] = { translation: languageAssets[code] };
  return acc;
}, {});

export default languageMap;
